export const PLACEHOLDER_NAME = '예) 홍길동';
export const PLACEHOLDER_PHONE = "'-' 제외 입력";
export const PLACEHOLDER_AUTH_CODE = '인증번호 4자리 입력';
export const PLACEHOLDER_TRANSPORTATION_LICENSE_NUMBER = '예) 34-000-0000';
export const PLACEHOLDER_SERVICE_REGIST_NUMBER = '예) 123-000-0000';
export const PLACEHOLDER_FRANCHISE = '업체명 입력';
export const PLACEHOLDER_SERVICE_NAME = '상호명을 입력해주세요.';
export const PLACEHOLDER_SERVICE_NAME_MOVE =
  '상호명(ex.짐싸, 짐싸 강남점)을 입력해주세요.';
export const PLACEHOLDER_INTRODUCE =
  '"안녕하세요. 이사 경력 OO년의 (기사 또는 업체)입니다. 하나부터 열까지 내 집처럼! 고객님의 소중한 짐, 꼼꼼하게 옮겨 드리겠습니다."';
export const PLACEHOLDER_SMALLMOVE_INTRODUCE =
  '"안녕하세요. 이사 경력 OO년의 (이름)기사 입니다. 하나부터 열까지 내 집처럼! 고객님의 소중한 짐, 꼼꼼하게 옮겨 드리겠습니다."';
export const PLACEHOLDER_FAMILYMOVE_INTRODUCE =
  '"안녕하세요. (이름)기사입니다. 하나부터 열까지 내 집처럼! 고객님의 소중한 짐, 꼼꼼하게 옮겨 드리겠습니다."';
export const PLACEHOLDER_CLEAN_INTRODUCE =
  '"안녕하세요! ㅇㅇㅇ 파트너입니다. 먼지 하나 없는 깔끔한 청소! OO년 경력의 ㅇㅇㅇ 저에게 꼭 맡겨주세요!"';
export const PLACEHOLDER_CAR_NUMBER = '숫자';
export const PLACEHOLDER_EMAIL_1 = '이메일을 입력해주세요.';
export const PLACEHOLDER_EMAIL_2 = '예) gmail.com';
export const PLACEHOLDER_SIZE = '평 수';
export const PLACEHOLDER_PRICE = '금액 입력';

export const BUTTON_NEXT = '다음';
export const BUTTON_PREV = '이전';
export const BUTTON_COMPLETE = '완료';
export const BUTTON_SEND_SMS = '인증받기';
export const BUTTON_RESEND_SMS = '재전송';
export const BUTTON_VERIFY_REQ = '인증확인';
export const BUTTON_VERIFY_COMPLETE = '인증완료';
export const BUTTON_LOGIN = '로그인';
export const BUTTON_LOGIN_2 = '이미 회원이신가요?';
export const BUTTON_LOGOUT = '로그아웃';
export const BUTTON_SIGNUP_1 = '회원가입';
export const BUTTON_SIGNUP_2 = '혹시 짐싸 파트너 회원이 아니신가요?';
export const BUTTON_CONFIRM = '확인';
export const BUTTON_DELETE_IMAGE = '사진 삭제';
export const BUTTON_ADD_CARINFO = '차량 추가하기';
export const BUTTON_ADD_USER = '직원추가';
export const BUTTON_MORE = '더보기';
export const BUTTON_CANCEL = '취소';
export const BUTTON_REGISTER = '등록';
export const BUTTON_SAVE = '저장';
export const BUTTON_REVIEW = '재등록';
export const BUTTON_DELETE = '삭제';

export const SELECT_DEFAULT_YEAR = '년';
export const SELECT_DEFAULT_MONTH = '월';
export const SELECT_DEFAULT_DAY = '일';
export const SELECT_DEFAULT_LOCATION_1 = '시, 도';
export const SELECT_DEFAULT_LOCATION_2 = '군, 구';
export const SELECT_DEFAULT_CAR_TYPE = '차량 종류를 선택해주세요.';
export const SELECT_DEFAULT_CAR_SIZE = '차량의 톤수를 선택해주세요.';
export const SELECT_DEFAULT_CAR_LOCATION = '지역을 선택해주세요.';
export const SELECT_DEFAULT_CAR_NUMBER = '한글';
export const SELECT_DEFAULT_CARRIERYEAR = '시작년도를 선택해주세요.';
export const SELECT_DEFAULT = '선택해주세요.';

export const LABEL_NAME = '이름';
export const LABEL_PHONE = '핸드폰 번호';
export const LABEL_TEL = '전화번호';
export const LABEL_BIRTHDAY = '생년월일';
export const LABEL_CARRIERYEAR = '활동 시작년도';
export const LABEL_STARTYEAR = '서비스 시작년도';
export const LABEL_LOCATION = '거주지역';
export const LABEL_LOCATION_FAMILY_MOVE = '사업장 소재지';
export const LABEL_SUBSCRIPTIONTYPE = '짐싸를 알게 된 경로가 어떻게 되나요?';
export const LABEL_BUSINESS_REGISTRATION_NUMBER = '사업자 등록번호';
export const LABEL_BUSINESS_REGISTRATION_IMG = '사업자 등록증사진';
export const LABEL_BUSINESS_REGISTRATION_OWNER = '사업자 명의';
export const LABEL_BUSINESS_REGISTRATION_NAME = '사업자 상호명';
export const LABEL_BUSINESS_REGISTRATION_DETAIL_ADDRESS = '상세 주소';
export const LABEL_SERVICE_IMAGE = '업체 로고';
export const LABEL_SERVICE_NAME = '상호명';
export const LABEL_CAR_IMAGE = '차량사진';
export const LABEL_CAR_NUMBER = '차량번호';
export const LABEL_EMAIL = '이메일';
export const LABEL_EMAIL_ADDR = '이메일 주소';
export const LABEL_ROLE = '권한';

export const LABEL_TAXCLASSIFICATION = '사업자정보';
export const LABEL_LICENSE_NUMBER = '화물운송종사자 자격 증명 번호 입력';
export const LABEL_LICENSE_IMG = '화물운송종사자 자격증 사진';
export const LABEL_POSSESSION_ARRANGE = '주선면허를 보유하고 있습니까?';
export const LABEL_POSSESSION_CARGO_INSURANCE =
  '적재물 보험을 보유하고 있습니까?';
export const LABEL_HAS_CARDREADER = '드 가맹점을 보유하고 있습니까?';
export const LABEL_CARINFO_SIZE = '차량톤수';
export const LABEL_CARINFO_TYPE = '차량종류';
export const LABEL_CARINFO_ETC = '차량옵션(복수 선택가능)';
export const LABEL_CARINFO_COLOR = '차량색상';
export const LABEL_CARINFO_COUNT = '차량 수';
export const LABEL_FRANCHISE = '가맹계약을 하고 있습니까?';
export const LABEL_IMG_UPLOAD = '사진 올리기';
export const LABEL_LOGO_UPLOAD = '업체 로고 올리기';
export const LABEL_INTRODUCE = '홍보 메세지';
export const LABEL_PROFILE_IMG = '프로필 사진';
export const LABEL_POPUP_PROFILE = '프로필 사진 예시';
export const LABEL_POPUP_FIELD_PHOTO = '활동 사진 예시';
export const LABEL_POPUP_SERVICE_IMG = '업체 로고 예시';
export const LABEL_SPENDINGONSALES = '매출대비 광고비 지출';
export const LABEL_ARRANGE_LICENSE =
  '(미가맹) 주선면허 허가증을 등록해주세요. or (가맹) 계약일, 계약서 명을 확인할 수 있도록 가맹 계약서를 등록해주세요.';
export const LABEL_INDEMNITY_INSURANCE = '이사 화물 배상책임 보험 사진';
export const LABEL_FRANCHISE_IMAGE =
  '계약일, 계약서 명을 확인할 수 있도록 가맹 계약서를 등록해주세요.';
export const LABEL_FRANCHISE_NAME = '가맹 업체명 입력';
export const LABEL_CARGO_LIABILITY_INSURANCE =
  '적재물 보험을 보유하고 있습니까?';
export const LABEL_CARGO_LIABILITY_INSURANCE_IMAGE = '적재물 보험 사진';
export const LABEL_FAMILY_RELATION_IMAGE = '가족관계증명서';
export const LABEL_SERVICE_REGISTER = '서비스 등록';
export const LABEL_SERVICE_CAR_REGISTER = '차량등록';
export const LABEL_MOVECLEANING_PROFILE_REGISTER = '프로필 등록';

export const SUB_LABEL_CARRIERYEAR = '이사를 시작한 년도를 선택해주세요.';
export const SUB_LABEL_BUSINESS_REGISTRATION_OWNER_FAMILY =
  '사업자 명의와의 족관계증명서를 첨부해주세요.(주민등록번호를 가리고 첨부해주세요.)';
export const SUB_LABEL_FRANCHISE = '예) 영구크린, 파란이사, 로젠이사 등';
export const SUB_LABEL_CLEANING_FIRST = '평 미만시, 고정 금액';
export const SUB_LABEL_CLEANING_SECOND = '평 이상시, 평 당';
export const SUB_LABEL_CLEANING_EXAMPLE_FIRST =
  '20평 미만 시, 고정 금액 160,000원';
export const SUB_LABEL_CLEANING_EXAMPLE_SECOND = '20평 이상 시, 평당 10,000원';

export const IMG_BUSINESS_REGISTRATION_OWNER_FAMILY =
  '가족관계증명서 사진 올리기';
export const IMG_BUSINESS_REGISTRATION_IMG = '사업자등록증 사진 올리기';
export const IMG_LICENSE_IMG = '화물운송종사자자격증 사진 올리기';

export const AGREEMENT_TERMS = '짐싸 이용약관';
export const AGREEMENT_PRIVACY = '개인정보 처리방침';
export const AGREEMENT_TEXT = '을 확인 하였으며, 동의 합니다.';

export const PAGE_MAIN_HEADER_TITLE = '짐싸 파트너 파트너 지원';
export const PAGE_MAIN_HEADER_SUBTITLE =
  '환영합니다! 성함과 연락처를 입력해주세요.';
export const PAGE_MOVESELECT_TITLE_1 = '선호하는 이사 종류를';
export const PAGE_MOVESELECT_TITLE_2 = '선택해주세요.';
export const PAGE_MOVESELECT_DESCRIPTION =
  '사는 주선면허를 보유하고 계신 사업자만 신청이 가능합니다.';

export const PAGE_MAIN_TITLE_1 = '반갑습니다. 파트너님!';
export const PAGE_MAIN_TITLE_2 = '짐싸 파트너 페이지입니다.';
export const PAGE_MAIN_CAPTION_1 =
  '고객에 대한 홍보는 짐싸가 책임질게요. 투명한 시스템을 통해 고객들께';
export const PAGE_MAIN_CAPTION_2 =
  '전문성을 인정받아 고정적인 일을 만들어 가세요!';

export const PAGE_SERVICE_SELECT_TITLE_1 = '안녕하세요. 짐싸 파트너에';
export const PAGE_SERVICE_SELECT_TITLE_2 = '오신걸 환영합니다.';
export const PAGE_SERVICE_SELECT_SUB_TITLE = '서비스를 선택해주세요.';
export const PAGE_SERVICE_SELECT_CAPTION =
  '*가정이사는 주선면허를 보유하거나 직영/가맹 계약이 되어있는 사업자만 신청이 가능합니다.';

export const PAGE_SERVICE_SMALLMOVE = '소형이사 서비스';
export const PAGE_SERVICE_SMALLMOVE_REGISTER_TITLE = '소형이사 등록';
export const PAGE_SERVICE_SMALLMOVE_PROFILE_REGISTER_TITLE =
  '소형이사 프로필 등록';
export const PAGE_SERVICE_FAMILYMOVE = '가정이사 서비스';
export const PAGE_SERVICE_FAMILYMOVE_REGISTER_TITLE = '가정이사 등록';
export const PAGE_SERVICE_FAMILYMOVE_PROFILE_REGISTER_TITLE =
  '가정이사 프로필 등록';

export const PAGE_SERVICE_MOVECLEANING = '청소 서비스';
export const PAGE_SERVICE_MOVECLEANING_PROFILE_REGISTER_TITLE =
  '청소 프로필 등록';

export const PAGE_SERVICE_MOVECLEANING_REGISTER_TITLE = '청소 등록';

export const PAGE_MY_PROFILE_TITLE = '내 프로필';

export const ALERT_IMG_UPLOAD_SIZE = '파일 용량을 초과 하였습니다.';
export const ALERT_IMG_UPLOAD_TYPE = '이미지 파일만 업로드 가능합니다.';
export const ALERT_IMG_UPLOAD_EXTENSION = '업로드 불가한 형식의 사진입니다.';
export const ALERT_IMG_UPLOAD_NO_SEARCH = '파일을 찾을 수 없습니다.';
export const ALERT_IMG_UPLOAD_FAIL = '파일 업로드를 실패하였습니다.';
export const ALERT_IMG_UPLOAD_COUNT_OVER =
  '최대 21장까지 사진 등록이 가능합니다.';
export const ALERT_NAME = '한글로 이름을 입력해주세요.';
export const ALERT_PHONE_PATTERN = '핸드폰 번호 형식이 맞지 않습니다.';
export const ALERT_VERIFY_SUCCESS = '핸드폰 번호 인증 완료하였습니다.';
export const ALERT_NUMBER = '정확한 번호를 입력 해주세요.';
export const ALERT_BIGGER_THAN_ONE = '1 이상의 숫자를 입력해주세요';

export const TITLE_PARTNER_SIGNUP = '짐싸 파트너 회원가입';
export const TITLE_PARTNER_LOGIN = '짐싸 파트너 로그인';
export const TITLE_DEFAULT_INFO = '기본정보';
export const TITLE_CERT_INFO = '서류정보';
export const TITLE_BUSINESS_INFO = '사업자 정보';
export const TITLE_ETC_INFO = '기타정보';
export const TITLE_CAR_INFO = '차량정보';
export const TITLE_FIELD_PHOTO = '활동 사진';
export const TITLE_PROFILE_INFO = '프로필 정보';
export const TITLE_COMP_INFO = '업체 정보';
export const TITLE_PROFILE = '기본 정보';
export const TITLE_USER_LIST = '직원목록';
export const TITLE_USER_REGISTER = '새로운 직원 정보';
export const TITLE_USER = '직원 정보';
export const TITLE_DOC_REVIEW = '서류 재등록';

export const CAPTION_BUSINESS_REGISTRATION_NAME =
  '* 반드시 사업자 등록증에 기재된 상호명을 입력해 주세요.';
export const CAPTION_START_YEAR =
  '*사실과 다를 경우 가입이 철회 될 수 있습니다.';
export const CAPTION_CAR_ETC = '*옵션이 없으면 선택하지 않으셔도 됩니다.';
export const CAPTION_EMAIL =
  '*결제 상세 내역을 전달 받으실 이메일 주소를 입력해주세요.';

export const CAPTION_PROFILE_IMG_1 =
  '위 이미지를 참고하시어 가이드 양식에 맞는 사진을 등록해주세요.';
export const CAPTION_PROFILE_IMG_2 = '아래와 같은 사진은 승인이 어렵습니다.';
export const CAPTION_PROFILE_IMG_3 = '업체 광고가 들어간 사진';
export const CAPTION_PROFILE_IMG_4 = '본인이 아닌 다른사람 사진';
export const CAPTION_PROFILE_IMG_5 = '셀프카메라 및 증명사진';
export const CAPTION_IMAGE_UPLOAD =
  '허위로 작성한 문서로인해 발생되는 법적피해는 본인에게 있습니다.';
export const CAPTION_FRANCHISE_IMAGE =
  '* 계약기간 및 대표자 서명이 보이게 사진을 등록해주세요.';

export const CAPTION_INTRODUCE_1 =
  '* 기본 정보를 기반으로 홍보메세지가 자동 입력됩니다.';
export const CAPTION_INTRODUCE_2 =
  '* 직접 입력 할 경우 위 박스를 클릭해 원하는 내용을 입력해주세요.';
export const CAPTION_INTRODUCE_3 =
  '* 전화번호 또는 타광고채널에 대한 내용이 있을경우 가입이 제한됩니다.';

export const ITEM_INFO_OWNER = '소장';
export const ITEM_INFO_FRANCHISE = '가맹정';
export const ITEM_INFO_SERVICE_LOCATION = '사업장 소재지';
export const ITEM_INFO_INTRODUCE = '홍보메세지';
export const ITEM_INFO_BUSINESS_REGISTRATION = '사업자등록증';
export const ITEM_INFO_TRANSPORTATION_LICENSE = '화물운송종사자 자격증';
export const ITEM_INFO_ARRANGE_LICENSE = '화물 자동차 운송 주선 사업허가증';
export const ITEM_INFO_INDEMNITY_INSURANCE = '이사화물배상 책임보험';
export const ITEM_INFO_CARGO_LIABILITY_INSURANCE = '화물 적재물보험';
export const ITEM_INFO_HAS_CARDREADER = '카드가맹점';
